export default __webpack_public_path__ + "static/media/icon-caret-down.084f9ec5.svg";